import React from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs } = props;
  const [open, setOpen] = React.useState(false);


  function handleClose() {
    setOpen(false);
  }

  function handleOpen() {
    setOpen(true);
  }
  return (
    <Modal
      size="sm"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal-right pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Employee List filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">

          <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="assetName"
                  name="assetName"
                  label="Asset name"
                  placeholder="Asset name"
                  className="w-100"
                  value={filterInputs.assetName}
                  onChange={(e) => filterInputsUpdate(e)}
                />

              </div>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="fullName"
                  name="fullName"
                  label=" Full name"
                  placeholder="Full name"
                  className="w-100"
                  value={filterInputs.fullName}
                  onChange={(e) => filterInputsUpdate(e)}
                />

              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  className="w-100"
                  value={filterInputs.email}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Phone number"
                  placeholder="Phone number"
                  className="w-100"
                  value={filterInputs.phoneNumber}
                  onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                {/* <TextField
                  id="isDeleted"
                  name="isDeleted"
                  label="Status"
                  placeholder="Status"
                  className="w-100"
                  value={filterInputs.isDeleted}
                  onChange={(e) => filterInputsUpdate(e)}
                /> */}
                  <FormControl className="w-100">
                  <InputLabel htmlFor="role">Status</InputLabel>
                  <Select
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={filterInputs.isActive}
                    onChange={(e) => filterInputsUpdate(e)}
                    inputProps={{
                      name: "isActive",
                      id: "isActive",
                    }}
                  >
                    <MenuItem value=" ">All</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                    <MenuItem value={true}>Active</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div> 

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
